(ns common.db.coeffects.cookie
  (:require [common.cookies :as cookies]
            [re-frame.core :as rf]))

(rf/reg-cofx :cookie/get
  (fn [cofx k]
    (assoc cofx k (cookies/get-cookie k))))
